import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function ExportToPDFButton({ handler }) {
  const {
    t,
  } = useTranslation();

  return (
    <Button onClick={handler} variant="danger" style={{ width: "100%" }} className="btn-wd btn-outline mr-1">
      <i className="fa fa-file-pdf" />{t("common.actions.export")}</Button>
  );
}
